import { Icon } from './Icon.jsx';

/**
 * Badge — status pill. Two shapes from the source "Type" axis:
 *   contained → radius 4, tinted bg (colour-10), colour-60 text, no dot;
 *   outlined  → radius 36 pill, tinted bg, colour-60 dot + text.
 * Colours: blue | green | orange | red | purple | yellow | neutral.
 * Height is fixed per size so a row of pills lines up — 22 (`small`) / 26 (`large`),
 * the two pill-tier locals of spec D6; only horizontal padding changes.
 *
 * Ported from the skill's components/data-display/Badge.jsx, prop names preserved
 * (HANDOFF.md:27). The reference computes the ramp name and the tier height in JS and
 * writes them into an inline style object; here the colour ramps and both tiers are
 * ds.css classes (spec S4, AC-9, AC-11). The `yellow` prop keeps its name; the ramp it
 * resolves to is `limeyellow`, exactly as in the reference.
 */
const COLORS = new Set(['blue', 'green', 'orange', 'red', 'purple', 'yellow', 'neutral']);

export function Badge ({
  children = 'Badge', color = 'green', type = 'outlined', size = 'small',
  removable = false, onRemove, className, ...rest
}) {
  const c = COLORS.has(color) ? color : 'green';
  const t = type === 'contained' ? 'contained' : 'outlined';
  const s = size === 'large' ? 'large' : 'small';

  return (
    <span
      className={['oc-badge', `oc-badge--${c}`, `oc-badge--${t}`, `oc-badge--${s}`, className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {t === 'outlined' && <span className="oc-badge__dot" aria-hidden="true" />}
      {children}
      {removable && (
        <button type="button" className="oc-badge__remove" onClick={onRemove} aria-label="Убрать">
          <Icon name="x" size="sm" />
        </button>
      )}
    </span>
  );
}
